import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_APPLICATIONS_ACTION_TYPE } from '../actions';

const initialState = {};

const loanApplicationsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, () => {
    switch (type) {
      case LOAN_APPLICATIONS_ACTION_TYPE.GET_LOAN_APPLICATIONS_BY_PARAMS:

      case LOAN_APPLICATIONS_ACTION_TYPE.GET_LOAN_APPLICATIONS_WITH_LEGACY: {
        const data = payload || initialState;

        return meta.isFirstFetch ? data : { ...state, ...data };
      }

      case LOAN_APPLICATIONS_ACTION_TYPE.RESET_LOAN_APPLICATIONS:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanApplicationsReducer;
